<section class="showcase">
    <div class="video-container">
        <video src="assets/video.mp4" autoplay loop muted width="100%"></video>
    </div>
    <div class="content">
        <h2>Welcome</h2>
        <ul>
            <li><a href="#aboutSection" class="btn">Intro <mat-icon>chevron_right</mat-icon></a></li>
            <li><a href="" class="btn" [routerLink]="['education']">Education <mat-icon>chevron_right</mat-icon></a></li>
            <li><a href="" class="btn" [routerLink]="['skills']">Skills <mat-icon>chevron_right</mat-icon></a></li>
            <li><a href="" class="btn" [routerLink]="['experience']">Experience <mat-icon>chevron_right</mat-icon></a></li>
        </ul>
    </div>
</section>

<mat-card class="aboutSection" id="aboutSection">
    
    <mat-card-header>
        <h2>Hello!</h2>
    </mat-card-header>
    
    <mat-card-content class="content-container">

        <div class="pic-container">
            <img src="../../assets/profile.png" alt="profile pic">
        </div>

        <div class="info-container">
            <p>A goal-oriented and intellectually curious MSc computer science student with an expected degree outcome of a First.</p>
            <p>Having spent time in a variety of professional work settings, I have gained experience in industries such as Banking and Finance <br> as well as Technology.</p>
            <p>A strong attention to detail coupled with an unparalleled work ethic has helped me to engage and succeed in each of these roles.</p>
            <span class="contactLinks">
                <a mat-fab class="mailButton" href="mailto:abeltomvarghese1998@gmail.com"><i class="fas fa-envelope"></i></a>
            </span>
            <span class="contactLinks">
                <a mat-fab class="linkedInButton" href="https://www.linkedin.com/in/abel-tom-varghese/"><i class="fab fa-linkedin-in"></i></a>
            </span>
            <span class="contactLinks">
                <a mat-fab class="gitButton" href="https://github.com/abeltomvarghese"><i class="fab fa-github"></i></a>
            </span>
        </div>

    </mat-card-content>

</mat-card>









